module.exports = __webpack_public_path__ + "static/media/hero-790x820.911f08c3.jpg";